import React from "react";

export default function Loading() {
  return <div className='loader'></div>;
}
